import { render, staticRenderFns } from "./ImageMultiple.vue?vue&type=template&id=21a95e74&"
import script from "./ImageMultiple.vue?vue&type=script&lang=js&"
export * from "./ImageMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports